import { css } from '@emotion/react'

import Colours from '@thebeansgroup/ui_style_helpers/colours'
import Fonts from '@thebeansgroup/ui_style_helpers/fonts'

export const alert = (isOfferIssuanceTile) => css`
  z-index: 3;
  position: absolute;
  line-height: 18px;
  color: ${Colours('white', '300')};
  font-family: ${Fonts('gibson')};
  font-size: 12px;
  top: ${isOfferIssuanceTile ? '6px' : '20px'};
  left: -5px;
  background-color: ${Colours('sourCherry', '300')};
  padding: 1px 8px 0px 8px;
  border-radius: 3px;
`

export const unavailable = css`
  background-color: ${Colours('liquorice', '500')};
`

export const exclusive = css`
  background-color: ${Colours('huckleberry', '300')};
`
